<script setup>
import { VNodeRenderer } from '@layouts/components/VNodeRenderer'
import { themeConfig } from '@themeConfig'
import authV2RegisterIllustrationBorderedDark from '@images/pages/auth-v2-register-illustration-bordered-dark.png'
import authV2RegisterIllustrationBorderedLight from '@images/pages/auth-v2-register-illustration-bordered-light.png'
import authV2RegisterIllustrationDark from '@images/pages/auth-v2-register-illustration-dark.png'
import authV2RegisterIllustrationLight from '@images/pages/auth-v2-register-illustration-light.png'
import authV2MaskDark from '@images/pages/misc-mask-dark.png'
import authV2MaskLight from '@images/pages/misc-mask-light.png'
import { useRouter } from 'vue-router'
import { useStrainStore } from '@core/stores/StrainStore'
import { useEquipmentStore } from '@core/stores/EquipmentStore'
import { useSupplyStore } from '@core/stores/SupplyStore'
import { useToolStore } from '@core/stores/ToolStore'
import { useEnvironmentStore } from '@core/stores/EnvironmentStore'
import { useGrowCycleStore } from '@core/stores/GrowCycleStore'
import RegistrationForm from '@/components/RegistrationForm.vue'
import permanentlyStoreSelectedItems from '@core/permanentlyStoreSelectedItems'

const imageVariant = useGenerateImageVariant(authV2RegisterIllustrationLight, authV2RegisterIllustrationDark, authV2RegisterIllustrationBorderedLight, authV2RegisterIllustrationBorderedDark, true)
const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark)

definePage({
  meta: {
    layout: 'blank',
    unauthenticatedOnly: true,
  },
})

const router = useRouter()

const strainStore = useStrainStore()
const equipmentStore = useEquipmentStore()
const supplyStore = useSupplyStore()
const toolStore = useToolStore()
const environmentStore = useEnvironmentStore()
const growCycleStore = useGrowCycleStore()

async function synchronizeStoredEntities() {
  await permanentlyStoreSelectedItems()

  strainStore.resetSelected()
  equipmentStore.resetSelected()
  supplyStore.resetSelected()
  toolStore.resetSelected()
  environmentStore.resetEnvironments()
  growCycleStore.resetGrowCycles()
}

async function finishRegistration() {
  await synchronizeStoredEntities()
  await router.push('/')
}
</script>

<template>
  <RouterLink to="/">
    <div class="auth-logo d-flex align-center gap-x-3">
      <VNodeRenderer :nodes="themeConfig.app.logo" />
      <h1 class="auth-title">
        {{ themeConfig.app.title }}
      </h1>
    </div>
  </RouterLink>

  <VRow
    no-gutters
    class="auth-wrapper bg-surface"
  >
    <VCol
      md="8"
      class="d-none d-md-flex"
    >
      <div class="position-relative bg-background w-100 me-0">
        <div
          class="d-flex align-center justify-center w-100 h-100"
          style="padding-inline: 100px;"
        >
          <VImg
            max-width="500"
            :src="imageVariant"
            class="auth-illustration mt-16 mb-2"
          />
        </div>

        <img
          class="auth-footer-mask"
          :src="authThemeMask"
          alt="auth-footer-mask"
          height="280"
          width="100"
        >
      </div>
    </VCol>

    <VCol
      cols="12"
      md="4"
      class="auth-card-v2 d-flex align-center justify-center"
      style="background-color: rgb(var(--v-theme-surface));"
    >
      <RegistrationForm @register="finishRegistration" />
    </VCol>
  </VRow>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
